import React, { useRef } from "react";
import {
    intl,
    DmsAltBox,
    DmsPage,
    DmsTable,
    DmsButtonGroup,
    DmsButton,
    getToken,
} from "dmsbasereact";
import { getBaseURL } from "../../build_config";
import Swal from "sweetalert2";
import { Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import { DATE_TIME_FORMATS } from "../../constants/DateTimeFormats";

export const CompletedTrainingsPage = () => {
    const table = useRef(null);

    const handleDownload = async (filePk, filename) => {
        try {
            const token = getToken();
            const url = `${getBaseURL()}/file/download?pk=${filePk}`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token.access_token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Download failed: ${response.statusText}`);
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = filename || "attendance-file";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: intl.get("DownloadError").d("Download Error"),
                text: err.message,
            });
        }
    };

    const header = [
        {
            label: intl.get("CompletionDate").d("Completion Date"),
            column_name: "completion_date",
            filter: true,
            control: "date",
            element: (row) => row.completion_date
                ? dayjs(row.completion_date).format(DATE_TIME_FORMATS.DAY_MONTH_YEAR_HOUR_MINUTE_SECOND)
                : "-",
        },
        {
            label: intl.get("TrainingName").d("Training Name"),
            column_name: "training_name",
            filter: true,
        },
        {
            label: intl.get("UserName").d("User Name"),
            column_name: "user_name",
            filter: true,
        },
        {
            label: intl.get("AttendanceFile").d("Attendance File"),
            column_name: "attendance_file",
            width: "150px",
            sortable: false,
            filter: false,
            element: (row) =>
                row.attendance_file_pk ? (
                    <DmsButtonGroup>
                        <DmsButton
                            icon={<DownloadIcon />}
                            onClick={() =>
                                handleDownload(
                                    row.attendance_file_pk,
                                    row.attendance_filename
                                )
                            }
                            title={intl.get("DownloadFile").d("Download File")}
                        />
                    </DmsButtonGroup>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        {intl.get("NoFile").d("No file")}
                    </Typography>
                ),
        },
    ];

    return (
        <DmsPage name={intl.get("CompletedTrainings").d("Completed Trainings")}>
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant="h3" sx={{ fontSize: "1.1rem" }}>
                        {intl.get("CompletedTrainings").d("Completed Trainings")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body>
                    <DmsTable
                        header={header}
                        managed={true}
                        needs_authentication={true}
                        ref={table}
                        url="/training_enrollment/completed/table"
                        export_table={false}
                    />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    );
};

export default CompletedTrainingsPage;
